import { axios } from 'shared/services/axios'

export function updateCookieMatching(type, value, success) {
  return axios.post('/live_board/v2/cookie_matchings', {
    type: type,
    value: value,
    success: success
  })
}
